module.exports = __webpack_public_path__ + "img/w3_circle_reload_dark.67a53034.png";